import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductDetailsShippingDefaults } from './shipping-defaults';
import { General } from '../general';
import { ProductDetailsActivity } from './activity/container';
import { Admin } from './admin';
import { Aliases } from './aliases';
import { ProductAliasesTabTitle } from './aliases-tab-title';
import { ProductDetailsCustomsDeclarations } from './customs-declarations';
import { ProductInventory } from './inventory';
import { ProductActiveShippingLocations } from './locations';
import Global from '../../../../store/global-selectors';
import { messages } from '../../messages';

export const general = {
  id: 'general',
  name: () => <FormattedMessage {...messages.generalTab} />,
  render: () => <General />,
  shouldRender: () => true,
};

export const shippingDefaults = {
  id: 'shipping-defaults',
  name: () => <FormattedMessage {...messages.shippingTab} />,
  render: () => <ProductDetailsShippingDefaults />,
  shouldRender: () => true,
};

export const admin = {
  id: 'admin',
  name: () => <FormattedMessage {...messages.adminTab} />,
  render: () => <Admin />,
  shouldRender: (state) => Global.selectUserisSysAdmin(state),
};

export const customsDeclaration = {
  id: 'customs-declarations',
  name: () => <FormattedMessage {...messages.customsTab} />,
  render: () => <ProductDetailsCustomsDeclarations />,
  shouldRender: () => true,
};

export const productInventory = {
  id: 'product-inventory',
  name: () => <FormattedMessage {...messages.productInventoryTab} />,
  render: () => <ProductInventory />,
  shouldRender: () => true,
};

export const productAliasesTab = {
  id: 'product-aliases',
  name: () => <ProductAliasesTabTitle />,
  render: () => <Aliases />,
  shouldRender: () => true,
};

export const productActivity = {
  id: 'product-activity',
  name: () => <FormattedMessage {...messages.productActivity} />,
  render: () => <ProductDetailsActivity />,
  shouldRender: () => true,
};

export const productActiveShippingLocations = {
  id: 'product-location',
  name: () => <FormattedMessage {...messages.productLocationsTab} />,
  render: () => <ProductActiveShippingLocations />,
  shouldRender: (_, additionalSettings) => additionalSettings.isSmartRoutingEnabled,
};

export const tabs = [
  general,
  shippingDefaults,
  customsDeclaration,
  productInventory,
  productAliasesTab,
  productActivity,
  productActiveShippingLocations,
  admin,
];
